import { render, staticRenderFns } from "./ForeignerText.vue?vue&type=template&id=dbca4fc0"
import script from "./ForeignerText.vue?vue&type=script&lang=js"
export * from "./ForeignerText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports